import React from 'react';

import {useTranslation} from 'react-i18next';
import {matchPath} from 'react-router-dom';

import {Breadcrumbs, BreadcrumbsProps} from 'components/ui-kit/Breadcrumbs';
import {history} from 'core/history';
import {ROUTES_DATA} from 'core/routes';

export const BreadcrumbsHeader = () => {
    const {t} = useTranslation();
    const getBreadcrumbs = () => {
        const {pathname} = history.location;

        return Object.entries(ROUTES_DATA)
            .map(([pathname, value]) => ({...value, pathname}))
            .map((route) => {
                const match = matchPath(pathname, {
                    path: route.pathname,
                    exact: false,
                    strict: false,
                });

                if (!match) return null;

                const label = route.key ? t('pages.declarations.breadcrumbs.' + route.key) : '';

                return {
                    label,
                    link: match.url,
                    active: match.isExact,
                };
            })
            .filter(Boolean) as BreadcrumbsProps['items'];
    };

    return <Breadcrumbs style={{marginBottom: '8px'}} items={getBreadcrumbs()} />;
};
